export default {
    blockReorderError_GENERIC_ERROR: 'Du har allerede et kort i bestilling.',
    blockReorderError_REBESTILLING_KREDITTKORT_AVVIST_NEXT:
        'Kunne ikke rebestille kort. Du har allerede et aktivt kort på denne kontoen.',
    blockReorderError_REBESTILLING_KREDITTKORT_AVVIST:
        'Kunne ikke rebestille kort. Du har allerede et aktivt kort på denne kontoen.',
    blockReorderError_REBESTILLING_KREDITTKORT_AVVIST_OVERTRUKKET:
        'Selvbetjent kortbestilling er ikke mulig når kortet er overtrukket. Ditt overtrekk er på kr {overdraft}. For hjelp, kontakt Eika Kundesenter på {phone}',
    blockReorderError_KORTET_ER_OVERTRUKKET:
        'Selvbetjent kortbestilling er ikke mulig når kortet er overtrukket. Ditt overtrekk er på kr {overdraft}. For hjelp, kontakt Eika Kundesenter på {phone}',
    blockReorderError_REORDER_DEBIT_CARD_ALREADY_IN_PROGRESS: 'Du har allerede et kort i bestilling.',
    blockReorderError_REORDER_CREDIT_CARD_ALREADY_IN_PROGRESS: 'Du har allerede et kort i bestilling.',
    blockReorderError_CANNOT_FIND_RELATED_CARD:
        'Kunne ikke rebestille kort. Vi finner ikke kortet du prøver å erstatte.',
    blockReorderError_TE_REORDER_FAIL_CARD_NOT_PRODUCED:
        'Kunne ikke rebestille kort. Kortet du prøver å erstatte er ikke produsert.',
    blockReorderError_TE_SYSTEM_ERROR: 'Noe gikk galt under rebestilling av kort. Vennligst prøv igjen senere.',
};
